import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useParams } from "react-router-dom";
import { decodeToken, getToken } from "../../utils/TokenUtils";
import { API_URL, ENDPOINTS } from "../../constants/api";
import axios from "axios";

const ClassPassCard2 = () => {
  const { route, class_id } = useParams();
  const token = getToken();
  const banner = decodeToken(token, "banner");
  const user_id = decodeToken(token, "id");

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/${route}`;
        const response = await axios.post(
          url,
          { class_id, user_id },
          { headers: { Authorization: token ? `Bearer ${token}` : "" } }
        );
        setData(response.data?.data || []);
      } catch (error) {
        console.error("Error fetching class data:", error);
      }
    };

    if (route) fetchData();
  }, [route, class_id, user_id, token]);

  useEffect(() => {
    if (data.length > 0) {
      const timer = setTimeout(() => window.print(), 800);
      return () => clearTimeout(timer);
    }
  }, [data]);

  if (!data.length) return null;

  // Ordinal helper
  const getDayWithSup = (day) => {
    const j = day % 10,
      k = day % 100;
    let suffix = "th";
    if (j === 1 && k !== 11) suffix = "st";
    else if (j === 2 && k !== 12) suffix = "nd";
    else if (j === 3 && k !== 13) suffix = "rd";
    return { day, suffix };
  };

  const formatDateWithSup = (dateStr) => {
    const date = new Date(dateStr);
    const { day, suffix } = getDayWithSup(date.getDate());
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();
    return { day, suffix, month, year };
  };

  const chunkArray = (arr, size) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };

  const groupedData = chunkArray(data, 4);

  return (
    <div>
      <style>
        {`
          .page {
            page-break-after: always;
            margin-bottom: 20px;
          }
        `}
      </style>

      {groupedData.map((group, pageIndex) => (
        <div key={pageIndex} className="page" style={{ padding: "10px" }}>
          {group.map((student, idx) => {
            const filteredData = Object.entries(student).filter(
              ([key]) => !key.startsWith("_")
            );
            const fromDate = formatDateWithSup(student._valid_from);
            const toDate = formatDateWithSup(student._valid_to);

            while (filteredData.length < 6) filteredData.push(["", ""]);

            return (
              <div
                key={idx}
                style={{
                  display: "flex",
                  marginBottom: "15px",
                  width: "100%",
                  gap: 0, // no gap between left and right
                }}
              >
                {/* Left: Passcard */}
                <div
                  style={{
                    flex: 1,
                    border: "2px solid #000",
                    borderRadius: "5px 0 0 5px", // rounded left side only
                    backgroundColor: "#fff",
                    padding: "10px",
                    fontFamily: "Arial, sans-serif",
                  }}
                >
                  <center>
                    <img
                      src={`${API_URL}/${banner}`}
                      alt="Banner"
                      style={{
                        width: "100%",
                        height: "80px",
                        borderRadius: "15px",
                        objectFit: "fill",
                      }}
                    />
                  </center>

                  <div
                    style={{
                      textAlign: "center",
                      marginTop: "10px",
                      color: "#016382",
                      fontWeight: "bold",
                      display: "flex",
                      justifyContent: "space-around",
                      textTransform: "uppercase",
                    }}
                  >
                    <div>{student._academic_year}</div>
                    <div>{student._title}</div>
                    <div>{student._exam_type}</div>
                  </div>

                  <div
                    style={{
                      textAlign: "center",
                      padding: "10px",
                      color: "#016382",
                    }}
                  >
                    -THIS CARD CERTIFIED THAT
                  </div>

                  <table
                    className="table table-bordered"
                    style={{ fontSize: "12px" }}
                  >
                    <thead>
                      <tr>
                        <th>{filteredData[0][0]}</th>
                        <th colSpan={3}>{filteredData[0][1]}</th>
                        <th colSpan={3}>
                          {filteredData[1][0]}: {filteredData[1][1]}
                        </th>
                      </tr>
                      <tr>
                        <th>{filteredData[2][0]}</th>
                        <th>{filteredData[2][1]}</th>
                        <th>{filteredData[3][0]}</th>
                        <th>{filteredData[3][1]}</th>
                        <th>{filteredData[4][0]}</th>
                        <th>{filteredData[4][1]}</th>
                      </tr>
                    </thead>
                  </table>

                  <div style={{ fontSize: "14px", color:"black", textAlign: "center" }}>
                    Valid from{" "}
                    <b>
                      {fromDate.day}
                      <sup>{fromDate.suffix}</sup> {fromDate.month},{" "}
                      {fromDate.year}
                    </b>{" "}
                    to{" "}
                    <b>
                      {toDate.day}
                      <sup>{toDate.suffix}</sup> {toDate.month},{" "}
                      {toDate.year}
                    </b>
                  </div>

                  <p
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      color:"black",
                      fontSize: "14px",
                    }}
                  >
                    {student._description}
                  </p>
                </div>

                {/* Right: Profile */}
                <div
                  style={{
                    width: "150px",
                    textAlign: "center",
                    border: "2px solid #000",
                    borderRadius: "0 5px 5px 0", // rounded right side only
                    padding: "5px",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "bold",
                      fontSize: "12px",
                      color: "green",
                      marginBottom: "5px",
                    }}
                  >
                    {student._exam_type}
                  </div>
                  <div
                    style={{
                      width: "100px",
                      height: "100px",
                      margin: "0 auto",
                      borderRadius: "50%",
                      overflow: "hidden",
                      border: "2px solid #ddd",
                    }}
                  >
                    <img
                      src={`${API_URL}/${student._photo}`}
                      alt="Student"
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                  </div>
                  <div
                    style={{
                      fontSize: "10px",
                      marginTop: "5px",
                      color: "green",
                    }}
                  >
                    {student._Date} <br />
                    <span style={{ fontWeight: "normal" }}>{student.User}</span>
                    <p style={{ color: "green" }}>____________________</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default ClassPassCard2;
